export default "__VITE_ASSET__QvANIKOj__"